import { http } from '../config/config-receituario'
import moment from 'moment'
moment.locale('pt-br')

export default {
    listar: async (token) => {
        return http.get('estoques', {
            headers: {
                'Authorization': token
            }
        })
    },
    findAllByProduct: async (token, id) => {
        return http.get(`estoques/produtos/${id}`, {
            headers: {
                'Authorization': token
            }
        })
    },
    findAllByDate: async (token, dtInicial, dtFinal, produto, receita, nf) => {
        const params = [];
        if (dtInicial != undefined && dtInicial.length > 0) {
            params.push("&data_inicial=");
            params.push(dtInicial);
        }
        if (dtFinal != undefined && dtFinal.length > 0) {
            params.push("&data_final=");
            params.push(dtFinal);
        }
        if (produto != undefined && produto.length > 0) {
            params.push("&produto=");
            params.push(produto);
        }
        if (receita != undefined && receita.length > 0) {
            params.push("&receita=");
            params.push(receita);
        }
        if (nf != undefined && nf.length > 0) {
            params.push("&nf=");
            params.push(nf);
        }
        const param = params.join('');
        console.log(param);
        return http.get(`estoques/filter?${param}`, {
            headers: {
                'Authorization': token
            }
        })
    },
    baixaReceituario: async (token, id) => {
        return http.get(`estoques/baixa/receita/${id}`, {
            headers: {
                'Authorization': token
            }
        })
    },
    altaEstoqueReceituario: async (token, id) => {
        return http.get(`estoques/alta/receita/${id}`, {
            headers: {
                'Authorization': token
            }
        })
    },
    salvar: (token, estoque) => {
        return http.post('estoques', estoque, {
            headers: {
                'Authorization': token
            }
        })
    },
    deletar: (token, id) => {
        return http.delete(`estoques/${id}`, {
            headers: {
                'Authorization': token
            }
        })
    },
    update: (token, estoque) => {
        return http.put(`estoques/${estoque.id}`, estoque, {
            headers: {
                'Authorization': token
            }
        })
    }

}